import { LOCALES } from 'utils/locale'

export const TURN = {
  [LOCALES.EN_US]: 'Turn',
  [LOCALES.ES_US]: 'Da vuelta',
}
